<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">{{$route.query.device_name}}</h1>
			<div class="clear marBottom20">
		  		<div class="fl" v-if="$route.query.addTerminalBtn=='true'">
					<el-button @click="showAddCon()"><i class="fa fa-plus"></i> 添加终端设备 </el-button>
					<el-button @click="showChoose()"><i class="fa fa-check-square"></i> 选择模板 </el-button>
					<el-button @click="showSetting()"><i class="fa fa-gear"></i> 设置为模板 </el-button>
				</div>
		  	</div>
			<el-table
		    	stripe
			    ref="multipleTable"
			    :data="deviceList"
			    tooltip-effect="dark"
			    style="width: 100%">
			    <el-table-column
			      type="index"
			      width="50">
			    </el-table-column>
				<el-table-column
			      prop="name"
			      label="名称">
			    </el-table-column>
			    <el-table-column
			      prop="mount_name"
			      label="设备类别">
			    </el-table-column>
			    <el-table-column
			      prop="product_name"
			      label="产品类型">
			    </el-table-column>
			    <el-table-column
			      prop="communication"
			      label="通讯协议"
			      show-overflow-tooltip>
			    </el-table-column>
			    <el-table-column
			      prop="postal_address"
			      label="通讯地址"
			      show-overflow-tooltip>
			    </el-table-column>
			    <!--<el-table-column
			      prop="activation_time"
			      label="激活时间"
			      :formatter="dateFormat">
			    </el-table-column>-->
			    <el-table-column
			      prop="remarks"
			      label="备注"
			      show-overflow-tooltip>
			    </el-table-column>
			    <!--<el-table-column
			      prop="status"
			      label="状态"
			      :formatter="ifActive"
			      show-overflow-tooltip>
			    </el-table-column>-->
			    <!--<el-table-column
			      label="可用日期">
			      	<template slot-scope="scope">
						<span :class="{dangerp:deadLineDays(scope.row.due_time)=='已过期'}" v-text="deadLineDays(scope.row.due_time)"></span>
					</template>
			    </el-table-column>-->
			    <el-table-column
		          label="操作">
		          <template slot-scope="scope">
		            <!--<el-button v-if="scope.row.status==0" type="text" size="small"
		                       @click="showActiveCon(scope.$index, scope.row)">激活
		            </el-button>
		            <el-button v-if="scope.row.status==1" type="text" size="small"
		                       @click="showActiveCon(scope.$index, scope.row)">续费激活
		            </el-button>
		            <el-button v-if="administrators==3 || administrators==5" type="text" size="small"
		                       @click="getActiveCode(scope.$index, scope.row)">获取激活码
		            </el-button>-->
		            <el-button type="text" size="small"
		                       @click="showEdit(scope.$index, scope.row)">编辑
		            </el-button>
		            <el-button type="text" size="small" v-if="$route.query.removeTerminalBtn=='true'"
		                       @click="showDelete(scope.$index, scope.row)">移除
		            </el-button>
		          </template>
		        </el-table-column>
			  </el-table>
		</div>
		<!--激活设备弹框-->
		<el-dialog title="设备激活" :visible.sync="activeFlag" width="500px">
        
	        <el-form>
	          <el-form-item label="激活码" :label-width="formLabelWidth">
	            <el-input v-model="cdkey" placeholder="请输入设备激活码激活" auto-complete="off"></el-input>
	          </el-form-item>
	        </el-form>
	        <div slot="footer" class="dialog-footer">
	          <el-button @click="addComFlag=false">取 消</el-button>
	          <el-button type="primary" @click="activeTerminal()">激 活</el-button>
	        </div>
	    </el-dialog>
		<!--添加终端设备弹框-->
		<el-dialog title="添加终端设备" :visible.sync="addFlag" width="500px">
			        
	       <add-terminal @childByValue="childByValue"></add-terminal>
	    </el-dialog>
	    <!--编辑弹框-->
		<el-dialog title="设备信息" :visible.sync="editFlag" width="500px">
        
	        <el-form ref="editDev" :model="editDev">
	        	
			    <el-form-item label="名称" :label-width="formLabelWidth">
			    	<el-input v-model="editDev.name" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="通讯地址" :label-width="formLabelWidth" prop="postal_address">
			    	<el-input v-model="editDev.postal_address" auto-complete="off"></el-input>
			    </el-form-item>
			    <el-form-item label="备注" :label-width="formLabelWidth">
			    	<el-input v-model="editDev.remarks" auto-complete="off"></el-input>
			    </el-form-item>
			    <br />
			    <el-form-item class="text-right">
			    	<el-button @click="editFlag=false">取 消</el-button>
	          		<el-button type="primary" @click="saveEdit()">确 定</el-button>
			    </el-form-item>
	        </el-form>
	    </el-dialog>
	    <!--移除提示框-->
	    <el-dialog title="提示框" :visible.sync="removeDevFlag" width="500px" >
		    <div class="userInfo">
				<h4>确认移除该终端设备吗？</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="removeDevFlag = false">取 消</el-button>
			    <el-button type="primary" @click="confirmRemovDev()">确 定</el-button>
			  </div>
		</el-dialog>
		<!-- 设置为模板组件 -->
	    <el-dialog title="提示框" :visible.sync="setFlag" width="500px">
		    <set-terminal-model :device_id='device_id' @setByValue="setByValue"></set-terminal-model>
		</el-dialog>
		<!-- 选择终端模板组件 -->
	    <el-dialog title="终端模板选择" :visible.sync="chooseFlag" width="900px">
		    <choose-model :device_id='device_id' @chooseByValue="chooseByValue"></choose-model>
		</el-dialog>
		
		
	</div>
</template>

<script>
	// 添加终端组件
	import addTerminal from '../comss/addTerminal';
	// 设置模板组件
	import setTerminalModel from '../comss/setTerminalModel';
	// 选择终端模板
	import chooseModel from '../comss/chooseModel';
	export default {		
		mounted() {
			this.$nextTick(function(){
				this.getDeviceList();
				console.log(this.$route.query.addTerminalBtn)
		  	})
		},
		components:{
			addTerminal,setTerminalModel,chooseModel
		},
		
    	data(){
    		return{
    			deviceList:[],
    			formLabelWidth:"90px",
    			addFlag:false,
    			addTeminal: {},
    			administrators:this.getCookie('administrators'),       			
    			activeDevId:-1,
    			activeFlag:false,
    			removeDevFlag:false,
    			editFlag:false,
    			cdkey:"",
    			removeDev:{},
				editDev:{},
				// 设置模板
				setFlag: false,
				device_id: this.$route.query.id,
				// 选择模板
				chooseFlag: false,

    		}
    	},
    	methods:{
    		showActiveCon(index,row){
    			this.cdkey = "";
    			this.activeFlag = true;
    			this.activeDevId = row.id;
    			
			},
			showChoose(){
				this.chooseFlag = true;
			},
			// 显示设置模板弹框
			showSetting(){
				this.setFlag = true;
			},
    		//设备激活
    		activeTerminal(){
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					cdkey:this.cdkey,
					mount_detail_id: this.activeDevId,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountDetailManage/Activation",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.activeFlag = false;
		        		this.$message.success(res.data.msg,2000);
		        		this.getDeviceList();
		        	}else if(res.data.code==10008){
		        		this.isLogouting = true;
						this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
			// 添加终端设备 子传父通讯
			childByValue(childValue) {
				// childValue就是子组件传过来的值
				this.addFlag = childValue
				this.getDeviceList();
			},
			// 设置为模板 子传父通讯
			setByValue(childValue){
				this.setFlag = childValue
			},
			// 选择模板 子传父通讯
			chooseByValue(childValue){
				this.getDeviceList();
				this.chooseFlag = childValue
			},
//  		点击编辑后弹框
			showEdit(index,row){
				this.editDev = row;
				this.editFlag = true;
			},
//  		确认编辑设备
    		saveEdit(){
    			let editParams={
					uid:this.getCookie('uid'),
					device_id:this.$route.query.id,
					id: this.editDev.id,
					name: this.editDev.name,
					postal_address: this.editDev.postal_address,
					remarks: this.editDev.remarks,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(editParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountDetailManage/UpdateMountDetail",this.$qs.stringify(editParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		setTimeout(()=>{
		        			this.getDeviceList();
		        		},500)
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
		  		this.editFlag = false;
    		},
//  		点击移除后显示弹框
    		showDelete(index,row){
    			this.removeDevFlag = true;
    			this.removeDev = row;
    		},
//  		确认移除设备
    		confirmRemovDev(){
    			let valiCodeParams={
					uid: this.getCookie('uid'),
					id: this.removeDev.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountDetailManage/DeleteMountDetail",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		setTimeout(()=>{
		        			this.getDeviceList();
		        		},500)
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		        	this.removeDevFlag = false;
		  		});
    		},
    		//获取激活码
    		getActiveCode(index,row){
    			let valiCodeParams={
					uid:this.getCookie('uid'),
					mount_detail_id: row.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/Cdkey/GainCdkey",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		this.$message.success("激活码："+res.data.data.cdkey,15000);
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		  		});
    		},
    	
    		//点击增加设备按钮
    		showAddCon(){
				this.addFlag = true;
    		},
    	
    		getDeviceList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					device_id:this.$route.query.id,
					page:1,
					pagesize:100,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/MountDetailManage/MountDetailList",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		if(res.data.data.datalist){
		        			this.deviceList = res.data.data.datalist || [];
		        		}
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});		  		
			},
    	}
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/device/terminalDevice.vue